import React, { useEffect, useState } from "react";
import {
  blackDeleteicon,
  editiconorange,
  rightarrowwhite,
} from "../../../images";
import TextFieldWithIcon from "../../../components/TextFieldWithIcon/TextFieldWithIcon";
import OtpInput from "react-otp-input";
import CountryCodeDropdown from "../../../components/CountryCodeDropdown/CountryCodeDropdown";
import { useWindowSize } from "react-use";

import Joi from "joi";
import http from "../../../helpers/http";
import { useAuth } from "../../../context/Auth/AuthState";
import config from "../../../config/config";
import { toast } from "react-toastify";
import ToastMsg from "../../../components/ToastMsg/ToastMsg";
import _find from "lodash/find";
import useTheme from "../../../components/useTheme/useTheme";

const EditOwnerWhatsapp = ({
  lightTheme,
  whatsapp_country_code,
  whatsapp_no,
  onChange,
  onDelete,
  contact_country_code,
  contact_phone,
  error,
}) => {
  const { theme } = useTheme();
  const { width } = useWindowSize();
  const [isWASame, setIsWASame] = useState(false);
  const [codes, setCodes] = useState([]);
  const [userCode, setUserCode] = useState(null);

  const base_url = config.api_url;

  // Fetch country codes (can keep)
  useEffect(() => {
    const fetchCodes = async () => {
      try {
        const response = await fetch(`${base_url}/general/countries/codes`);
        const result = await response.json();
        // Ensure we store an array
        const codesArray = result?.data || [];
        setCodes(Array.isArray(codesArray) ? codesArray : []);
      } catch (err) {
        console.error("Failed to fetch country codes", err);
        setCodes([]);
      }
    };
    fetchCodes();
  }, []);

  useEffect(() => {
    if (codes.length > 0 && whatsapp_country_code) {
      const found = codes.find((c) => c.phone_code === whatsapp_country_code);
      setUserCode(
        found || codes.find((c) => c.phone_code === "91") || codes[0]
      );
    }
  }, [whatsapp_country_code, codes]);

  const handleWAChange = (e) => {
    setIsWASame(e.target.checked);
  };

  // Sync WhatsApp when checkbox is checked
  useEffect(() => {
    if (isWASame) {
      onChange("whatsapp_no", contact_phone);
      onChange("whatsapp_country_code", contact_country_code);

      const found = codes.find((c) => c.phone_code === contact_country_code);
      setUserCode(found || codes[0]);
    }
  }, [contact_phone, contact_country_code, isWASame, codes, onChange]);

  return (
    <div className="field_wrapper padding_left">
      <div className="row">
        <div className="col-4 col-sm-4 col-md-4 ps-0">
          <div className="field_wrapper_1">
            <CountryCodeDropdown
              textLabel="Code*"
              data={codes}
              value={userCode}
              lightTheme={lightTheme}
              onChange={(event, option) => {
                if (option) {
                  setUserCode(option);
                  onChange("whatsapp_country_code", option.phone_code);
                }
              }}
            />
          </div>
        </div>
        <div
          className={`col-8 col-sm-7 col-md-7 ${
            width > 992 ? "pe-0" : "ps-0 pe-0"
          }`}
        >
          <div className="field_wrapper_1">
            <TextFieldWithIcon
              label="WhatsApp number*"
              icon={editiconorange}
              value={whatsapp_no}
              lightTheme={lightTheme}
              type="tel"
              onChange={(e) => {
                let val = e.target.value.replace(/\D/g, ""); // digits only
                if (val.length > 10) val = val.slice(0, 10);
                onChange("whatsapp_no", val);
                if (isWASame) setIsWASame(false);
              }}
            />
            {error && <p className="error">{error}</p>}
          </div>
        </div>
        {width >= 576 && (
          <div className="col-1 col-sm-1 col-md-1 trash_icon_holder p-0">
            <img
              src={blackDeleteicon}
              alt="Trash Icon" onClick={onDelete}
              style={{
                filter: theme === "light" ? "invert(0)" : "invert(1)",
              }}
            />
          </div>
        )}
      </div>

      <div className="row mt-4 mt-sm-0">
        <div className="checkbox_wrapper col-8">
          <label className="checkbox_label">
            <input
              type="checkbox"
              className="check_box"
              checked={isWASame}
              onChange={handleWAChange}
            />
            Same as phone number
          </label>
        </div>
        {width < 576 && (
          <div className="col-4 trash_icon_holder p-0">
            <img src={blackDeleteicon} alt="Trash Icon" onClick={onDelete} />
          </div>
        )}
      </div>
    </div>
  );
};

export default EditOwnerWhatsapp;
